import trim from 'lodash/trim.js';
import { hooks } from '../wpHooks/index.js';
export function getWpUrl(path = '') {
    let wpUrl = trim(process.env.NEXT_PUBLIC_WORDPRESS_URL, '/');
    wpUrl = hooks.applyFilters('wpUrl', wpUrl, {});
    if (!path) {
        return wpUrl;
    }
    return `${wpUrl}/${path}`;
}
